module.exports = __webpack_public_path__ + "static/media/help.2508df20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/views/images/help.svg
// module id = 689
// module chunks = 0